module.exports = __webpack_public_path__ + "5d7c31b284ddb01fc1cbae0edc9ec210.ttf";